import classNames from 'classnames';

import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import NetworkError from '@/uikit/errors/NetworkError/NetworkError';
import Loader from '@/uikit/Loader/Loader';

import styles from './styles.module.scss';

interface LoaderContainerProps {
  className?: string,
  loading?: boolean,
  error?: string,
  noData?: boolean,
}

const LoaderContainer: FC<PropsWithChildren<LoaderContainerProps>> = ({
  children,
  className,
  loading,
  error,
  noData,
}) => {
  const { t } = useTranslation();

  const cn = classNames(styles.loaderContainer, className);

  if (loading) {
    return (
      <div className={cn}>
        <Loader className={styles.loader} />
      </div>
    );
  }

  if (error) return <NetworkError />;

  if (noData) {
    return (
      <div className={styles.noData}>
        {t('components.LoaderContainer.noData')}
      </div>
    );
  }

  return children as JSX.Element;
};

export default LoaderContainer;
